export function autoAppyAppInitials(name = '') {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase() || 'AA';
}

const internalApplicationNames = new Set([
  'auto appy sso',
  'autoappy sso',
]);

export function autoAppySwitcherApps(apps = []) {
  if (!Array.isArray(apps)) return [];

  return apps.filter((app) => {
    if (!app || app.visible_in_switcher === false) return false;

    const applicationType = String(app.type || app.purpose || app.visibility || '').toLowerCase();
    if (['developer', 'internal'].includes(applicationType)) return false;

    return !internalApplicationNames.has(String(app.name || '').trim().toLowerCase());
  });
}

export function autoAppyAppLaunchUrl(app, workspaceId) {
  try {
    const url = new URL(app.frontend_url);
    // AUTO-WA-39: the main app's workspace now opens on Home (AUTO-319).
    if (app.key === 'main' && url.pathname === '/') url.pathname = '/home';
    if (workspaceId) url.searchParams.set(app.key === 'main' ? 'organisation' : 'workspace', workspaceId);
    return url.toString();
  } catch {
    return app.frontend_url || '#';
  }
}

// AUTO-WA-39: one mark per product in the switcher, shared with the AI and CRM
// Stage ports (every name starts "Auto Appy", so initials alone read "AA").
const PRODUCT_MARKS = { main: 'AA', whatsapp: 'WA', crm: 'CRM', ai: 'AI', 'auto-appy-ai': 'AI' };

export function autoAppyProductMark(app = {}) {
  if (PRODUCT_MARKS[app.key]) return PRODUCT_MARKS[app.key];
  const rest = String(app.name || '').replace(/^auto\s*appy\s*/i, '');
  return autoAppyAppInitials(rest || app.name);
}
